import "./i18n";

import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";

import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider context={{}}>
    <Provider store={store}>
      {/* <React.StrictMode> */}
      <StyleProvider transformers={[legacyLogicalPropertiesTransformer]}>
        <App />
      </StyleProvider>
      {/* </React.StrictMode> */}
    </Provider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
